import { SimpleSelectField } from '@navinc/base-react-components/wayfinder'

import { cmsGraphql, FragmentType, getFragmentData } from '../../../lib/cms/index.js'
import { ValidationError } from '../types.js'

export const creditQualityFragment = cmsGraphql(/* GraphQL */ `
  fragment creditQualityFragment on CmsCreditQualityFormField {
    name
    label
    required
  }
`)

export type CreditQualitySelectProps = {
  data: FragmentType<typeof creditQualityFragment>
  validationError?: ValidationError
}

const creditQualityOptions: { label: string; value: string }[] = [
  { label: '300-449 (Very Poor)', value: 'F' },
  { label: '450-524 (Poor)', value: 'D2' },
  { label: '525-579 (Bad)', value: 'D1' },
  { label: '580-624 (Okay)', value: 'C2' },
  { label: '625-679 (Fair)', value: 'C1' },
  { label: '680-699 (Good)', value: 'B2' },
  { label: '700-724 (Very Good)', value: 'B1' },
  { label: '725-749 (Great!)', value: 'A3' },
  { label: '750-799 (Excellent!)', value: 'A2' },
  { label: '800-850 (Superb!)', value: 'A1' },
]

export const CreditQualitySelect = ({ data, validationError }: CreditQualitySelectProps) => {
  const { name, label, required } = getFragmentData(creditQualityFragment, data)
  return (
    <SimpleSelectField
      name={name ?? undefined}
      label={label}
      defaultValue={undefined}
      required={required ?? undefined}
      error={validationError?.data?.errors?.find((error) => error.path === name)?.message}
      options={creditQualityOptions}
    />
  )
}
